// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YCPmx","innerContainer":"_1Je3G"};